import { Pipe, PipeTransform } from '@angular/core'
import { PatientNameSchema } from '@mmx/shared'

@Pipe({
  name: 'humanName',
  pure: false,
  standalone: false,
})
export class HumanNamePipe implements PipeTransform {
  transform(name?: PatientNameSchema, full = false) {
    if (name) {
      if (full) {
        const firstGroup = [name.family, name.suffix]

        const first = firstGroup.join(' ').trim()

        const secondGroup = [
          name.prefix ? name.prefix + '.' : '',
          name.given,
          name.nick ? `"${name.nick}"` : '',
          name.middle,
        ].filter((part) => {
          return part && part !== ''
        })

        const second = secondGroup.join(' ').trim()

        if (first && second) {
          return `${first}, ${second}`.toUpperCase()
        } else {
          return (
            first ||
            second ||
            name.family ||
            name.given ||
            ''
          ).toUpperCase()
        }
      } else if (name.family && name.given) {
        return `${name.family}, ${name.given}`.toUpperCase()
      } else {
        return (name.family || name.given || name.nick || '').toUpperCase()
      }
    } else {
      return ''
    }
  }
}
